module.exports = __webpack_public_path__ + "img/golang.5e0ff338.svg";